import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { applicationEditService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type applicationHistoryProps = {
	historyKey: string;
	fetchData: {
		page: number;
	};
	id: number | string;
};

const useGetApplicationHistoryQuery = ({
	historyKey,
	fetchData,
	id,
}: applicationHistoryProps) => {
	const dispatch = useDispatch();

	const { page } = fetchData || {};

	const queryResult = useQuery(
		[historyKey, page],

		() => applicationEditService.getApplicationHistory({ page, id }),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!id,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetApplicationHistoryQuery;
